'use strict'

var Marionette = require('marionette')
var App = require('app')

module.exports.Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  triggers: {
    'click .js-tab-nodes': 'tab:nodes',
    'click .js-tab-gateways': 'tab:gateways',
    'click .js-tab-groups': 'tab:groups',
    'click .js-tab-users': 'tab:users'
  },
  className: 'page page__client',
  regions: {
    headerRegion: '.account__section',
    contentRegion: '.tab__content'
  },
  onBeforeRender: function () {}
})



// WEBPACK FOOTER //
// ./js/modules/styleguide/show/view.js